import { render, staticRenderFns } from "./pipe-email-confirm.vue?vue&type=template&id=f5444a2a&scoped=true"
import script from "./pipe-email-confirm.vue?vue&type=script&lang=js"
export * from "./pipe-email-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5444a2a",
  null
  
)

export default component.exports